<script lang="ts">
  import { roundOf } from "../../helpers/priceCalculator";
  import type { Product, CostCalculation, PriceComparison } from "../../helpers/types";
  import Text from "../atoms/Text.svelte";

  interface Props {
    product: Product;
  }

  let { product }: Props = $props();

  const KWH_LEVELS = [2000, 5000, 20000] as const;

  const calculatePrice = (kwh: number, costs: CostCalculation | undefined): number | undefined => {
    if (!costs) return undefined;
    const kwhCost = costs.discount?.kwhCost ?? costs.kwhCost;
    const fixedCost = costs.discount?.fixedCost ?? costs.fixedCost;
    const totalAnnualCost = kwh * kwhCost * 100 + 12 * fixedCost * 100;
    const costPerKwh = totalAnnualCost / kwh;
    return roundOf(costPerKwh * (1 + costs.vat / 100), 100);
  };

  const priceIsFromAPI = $derived(product.priceComparison?.Compare2000 !== undefined);

  const getPrice = (kwh: (typeof KWH_LEVELS)[number]): string | number | undefined => {
    if (priceIsFromAPI)
      return product.priceComparison?.[`Compare${kwh}` as keyof PriceComparison] as
        | string
        | undefined;
    return calculatePrice(kwh, product.costs);
  };
</script>

<div class="text-Neutral900 text-S">
  {#each KWH_LEVELS as kwh}
    <Text variant="primary">{kwh} kWh: {getPrice(kwh)} öre/kWh</Text>
  {/each}
</div>
